import { useState } from "react";
import { toast } from "sonner";
import { createLead } from "../lib/api";

export const LeadForm = ({ kind = "medical_card", cta = "Request Consultation", defaultCity = "" }) => {
  const [form, setForm] = useState({ name: "", email: "", phone: "", city: defaultCity, message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.phone) {
      toast.error("Please fill name, email and phone.");
      return;
    }
    setLoading(true);
    try {
      await createLead({ ...form, kind });
      toast.success("Received! A BeeHive pharmacist will reach out shortly.");
      setForm({ name: "", email: "", phone: "", city: defaultCity, message: "" });
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const field = "bg-transparent border-b border-bone/30 px-0 py-4 rounded-none focus:border-honey text-bone placeholder-stone w-full outline-none transition-colors";

  return (
    <form data-testid="lead-form" onSubmit={submit} className="space-y-8">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <input data-testid="lead-name" className={field} placeholder="Full Name"
          value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
        <input data-testid="lead-phone" className={field} placeholder="Phone"
          value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
        <input data-testid="lead-email" type="email" className={field} placeholder="Email"
          value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
        <input data-testid="lead-city" className={field} placeholder="City"
          value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} />
      </div>
      <textarea data-testid="lead-message" rows={3} className={field} placeholder="Tell us what you need help with (optional)"
        value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
      <button
        data-testid="lead-submit"
        disabled={loading}
        className="rounded-full bg-honey text-ink px-10 py-4 font-bold tracking-widest uppercase hover:bg-bone hover:scale-105 transition-all duration-300 disabled:opacity-60"
      >
        {loading ? "Sending…" : cta}
      </button>
    </form>
  );
};
